import fpApiUtil from "./fp-api-util";
import { restApiFP } from "@plannel/services/utils/rest-api";
import axiosUtil from "@plannel/utils/axios-bigint";

// 시나리오(계획 정책) 헤더 + 상세(전략/규칙 선택·순서)를 한 번에 저장.
// SimulationController.savePlanPolicyAndDetails는 changes(=Map<String,String>)와 plan-scope를
// **별도 form 필드**로 읽고, changes.data는 상세 행 배열의 **JSON 문자열**이어야 한다
// (배열 그대로 넣으면 Map<String,String> 역직렬화에서 실패). 서버는 기존 상세를 전량 삭제 후
// 받은 목록을 다시 넣는다(delete-all + reinsert).
// policyCd가 비어 있으면 서버가 `FP_POLICY_<yyyyMMddHHmmss>`를 채번하고 data.newPlanPolicy로 돌려준다.
//
// changes가 Map<String,String>이라 boolean도 문자열로 넘긴다 — 서버는 Boolean.parseBoolean으로 읽는다.
const save = ({
  planScope,
  policyCd,
  policyNm,
  plannerNm,
  inScriptNm,
  inScriptUseYn,
  outScriptNm,
  outScriptUseYn,
  details
}) =>
  fpApiUtil.postFields("factoryplan/simulation/simulation-scenario/policy-dtls", {
    changes: {
      data: axiosUtil.jsonbigStringfy(details ?? []),
      policyCd: policyCd ?? null,
      policyNm: policyNm ?? "",
      plannerNm: plannerNm ?? "",
      inScriptNm: inScriptNm ?? "",
      inScriptUseYn: String(Boolean(inScriptUseYn)),
      outScriptNm: outScriptNm ?? "",
      outScriptUseYn: String(Boolean(outScriptUseYn))
    },
    "plan-scope": planScope
  });

// 고를 수 있는 플래너 목록. 서버(PlannerFactory)가 클래스패스에서 실제로 찾은 것만 준다 —
// 화면에 목록을 하드코딩하면 커스텀 플래너를 추가할 때마다 화면을 고쳐야 한다.
const getPlannerNames = async () => {
  const response = await restApiFP.get("factoryplan/simulation/planner-names");
  return response?.data ?? [];
};

const fpSimulationScenarioService = { save, getPlannerNames };
export default fpSimulationScenarioService;
